export default __webpack_public_path__ + "static/media/Preloader.33df8b57.svg";